/**
 * App 컴포넌트
 * @module app/App
 * @author Olive
 */
import { ReactElement } from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';

import { GlobalLoadingBar } from '@/shared/components/LoadingBar.tsx';
import { LoadingBarProvider } from '@/shared/components/LoadingBarContext.tsx';
import { Toaster } from '@/shared/components/ui/sonner.tsx';

import Routers from './Routers.tsx';

const queryClient = new QueryClient();

/**
 * App 컴포넌트를 초기화합니다.
 * @author Olive
 */
const App = (): ReactElement => {
  return (
    <QueryClientProvider client={queryClient}>
      <LoadingBarProvider>
        <GlobalLoadingBar />
        <Toaster richColors position="bottom-right" offset={{ right: 100 }} />
        <RouterProvider router={Routers} />
      </LoadingBarProvider>
    </QueryClientProvider>
  );
};

export default App;
